import TemplateView from '../../../../TemplateView'
import {paymentMethod, purchaseStep, purchaseStrategyType} from '../../constants'
import Button from '../../../../components/Button'
import messageResource from '../../../../messageResource'
import ConfigureAccountFooter from './accountInfo/ConfigureAccountFooter'
import FinalFooter from './paymentStep/FinalFooter'
import SuccessFooter from './successStep/SuccessFooter'
import {connect} from '../../../../redux/utils'
import {
    areAgreementsConfirmed,
    areNewAgreementsNeeded,
    canGetFreeLicense,
    canGetLicense,
    getPaymentMethod,
    getTotalPrice,
    hasAllCompanyInfo,
    isContextCorrect,
    isTransferHostingZoneProcessing
} from './selectors'
import NumberFormatter from '../../../../number_formatter'
import {ProductWebSiteURLs} from '../../../../constants'

class PurchaseLightBoxFooter extends TemplateView {
    constructor({
        companyInfoContinueButtonClick = () => {},
        accountInfoContinueButtonClick = () => {},
        getFreeLicenseButtonClick = () => {},
        onPayButtonClick = () => {},
        onBackButtonClick = () => {},
        onConfirmAgreementClick = () => {},
    } = {}) {
        super()

        this.callbacks = {
            companyInfoContinueButtonClick,
            accountInfoContinueButtonClick,
            getFreeLicenseButtonClick,
            onPayButtonClick,
            onBackButtonClick,
            onConfirmAgreementClick,
        }

        this.state = {
            purchaseStep: purchaseStep.COMPANY_INFO,
            purchaseStrategyType: '',
            totalNumberSteps: 0,
            companyInfoContinueAvailable: false,
            accountInfoContinueAvailable: false,
            getLicenceAvailable: false,
            getFreeLicenceAvailable: false,
            paymentMethod: '',
            price: 0,
            transferHostingZoneProcessing: false,
            newAgreementsNeeded: false,
            agreementsConfirmed: false,
        }

        this.onAnyStatePropertyChanged(['purchaseStep', 'transferHostingZoneProcessing'], () => {
            this.$companyInfo.toggle(this.state.purchaseStep === purchaseStep.COMPANY_INFO)
            this.$accountInfo.toggle(this.state.purchaseStep === purchaseStep.ACCOUNT_INFO)
            this.$payment.toggle(this.state.purchaseStep === purchaseStep.PAYMENT)
            this.$success.toggle(this.state.purchaseStep === purchaseStep.SUCCESS && !this.state.transferHostingZoneProcessing)

            this.getEl().toggleClass('emptyFooter', this.state.purchaseStep === purchaseStep.SUCCESS && this.state.transferHostingZoneProcessing)

        })

        this.onStatePropertyChanged('companyInfoContinueAvailable', (available) => {
            this.companyInfoContinueButton.setState({disabled: !available})
        })

        this.onStatePropertyChanged('accountInfoContinueAvailable', (continueAvailable) => {
            this.configureAccountFooter.setState({continueDisabled: !continueAvailable})
        })

        this.onStatePropertyChanged('getLicenceAvailable', (getLicenceAvailable) => {
            this.paymentFooter.setState({disablePayButton: !getLicenceAvailable})
        })

        this.onStatePropertyChanged('getFreeLicenceAvailable', (getFreeLicenceAvailable) => {
            this.getFreeFooter.setState({disablePayButton: !getFreeLicenceAvailable})
        })

        this.onAnyStatePropertyChanged(['paymentMethod', 'price'], () => {
            let text = messageResource.getMessage('licenses.purchase.purchase_step.pay_button', [this.numberFormatter.format(this.state.price / 100)])
            if (this.state.paymentMethod !== paymentMethod.CC) {
                text = messageResource.getMessage('licenses.purchase.purchase_step.request_invoice')
            }

            this.paymentFooter.setState({
                payButtonText: text,
            })
        })

        this.onStatePropertyChanged('purchaseStrategyType', () => {
            this.$accountInfoContinue.toggle(this.state.purchaseStrategyType !== purchaseStrategyType.FIRST_FREE)
            this.$accountInfoGetFree.toggle(this.state.purchaseStrategyType === purchaseStrategyType.FIRST_FREE)
        })

        this.onAnyStatePropertyChanged(['purchaseStrategyType', 'totalNumberSteps'], () => {
            this.paymentFooter.setState({
                hideBackButton: (this.state.purchaseStrategyType === purchaseStrategyType.PURCHASE || this.state.purchaseStrategyType === purchaseStrategyType.ADD_USERS) &&
                                this.state.totalNumberSteps === 1
            })
        })

        this.onAnyStatePropertyChanged(['newAgreementsNeeded', 'agreementsConfirmed'], () => {
            this.getFreeFooter.setState({
                needConfirmAgreement: this.state.newAgreementsNeeded,
                agreementsConfirmed: this.state.agreementsConfirmed,
            })
            this.paymentFooter.setState({
                needConfirmAgreement: this.state.newAgreementsNeeded,
                agreementsConfirmed: this.state.agreementsConfirmed,
            })
        })
    }

    templateHtml() {
        return '<div class="footer">' +
               '    <div class="companyInfo"/>' +
               '    <div class="accountInfo">' +
               '        <div class="continue"/>' +
               '        <div class="getFree"/>' +
               '    </div>' +
               '    <div class="payment"/>' +
               '    <div class="success"/>' +
               '</div>'
    }

    afterRender() {
        this.$companyInfo = this.find('.companyInfo')
        this.companyInfoContinueButton = new Button({
            additionalClass: 'continueButton',
            label: messageResource.getMessage('licenses.purchase_lightbox.company_info_continue'),
            onClickCb: this.callbacks.companyInfoContinueButtonClick,
        }).init(this.$companyInfo)

        this.$accountInfo = this.find('.accountInfo')
        this.$accountInfoContinue = this.find('.accountInfo .continue')
        this.$accountInfoGetFree = this.find('.accountInfo .getFree')
        this.configureAccountFooter = new ConfigureAccountFooter({
            continueButtonClickCallback: this.callbacks.accountInfoContinueButtonClick,
            backButtonClickCallback: this.callbacks.onBackButtonClick,
        }).init(this.$accountInfoContinue)
        this.getFreeFooter = new FinalFooter({
            onPayButtonClick: this.callbacks.getFreeLicenseButtonClick,
            onBackButtonClick: this.callbacks.onBackButtonClick,
            payButtonText: messageResource.getMessage('licenses.purchase_lightbox.get_free.get_license'),
            onConfirmAgreementClick: this.callbacks.onConfirmAgreementClick,
            serviceAgreementLink: ProductWebSiteURLs.SERVICE_AGREEMENT_URL,
            dataProcessingAgreementLink: ProductWebSiteURLs.DATA_PROCESSING_AGREEMENT_URL,
        }).init(this.$accountInfoGetFree)

        this.$payment = this.find('.payment')
        this.paymentFooter = new FinalFooter({
            onBackButtonClick: this.callbacks.onBackButtonClick,
            onPayButtonClick: this.callbacks.onPayButtonClick,
            onConfirmAgreementClick: this.callbacks.onConfirmAgreementClick,
            serviceAgreementLink: ProductWebSiteURLs.SERVICE_AGREEMENT_URL,
            dataProcessingAgreementLink: ProductWebSiteURLs.DATA_PROCESSING_AGREEMENT_URL,
        }).init(this.$payment)

        this.$success = this.find('.success')
        this.success = new SuccessFooter().init(this.$success)

        this.numberFormatter = new NumberFormatter(window.SystemSettings.decimalSeparator, window.SystemSettings.digitGroupingSymbol, 2, false)

        this.renderInitialState()
    }

    //for compatibility with LightBox
    getCommitBtnEl() {
        return []
    }

    //for compatibility with LightBox
    getCancelBtnEl() {
        return []
    }
}

export default connect(
    (state) => ({
        companyInfoContinueAvailable: hasAllCompanyInfo(state),
        accountInfoContinueAvailable: isContextCorrect(state),
        getLicenceAvailable: canGetLicense(state),
        getFreeLicenceAvailable: canGetFreeLicense(state),
        paymentMethod: getPaymentMethod(state),
        price: getTotalPrice(state),
        transferHostingZoneProcessing: isTransferHostingZoneProcessing(state),
        newAgreementsNeeded: areNewAgreementsNeeded(state),
        agreementsConfirmed: areAgreementsConfirmed(state),
    }),
)(PurchaseLightBoxFooter)


// WEBPACK FOOTER //
// ./web/js/administration/licenses/components/purchaseLightBox/PurchaseLightBoxFooter.js